define('home/templates/message',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression;

  return "<div class=\"alert-message-success\">\n<div class=\"section-contained alert-message\">\n"
    + alias1(container.lambda((depth0 != null ? depth0.message : depth0), depth0))
    + "\n<button class=\"close\" aria-hidden=\"true\" title=\""
    + alias1(helpers.gettext.call(depth0 != null ? depth0 : {},"Don't show this message again",{"name":"gettext","hash":{},"data":data}))
    + "\" data-action=\"hide-message\">\n<span class=\"icon-cancel\"></span>\n</button>\n</div>\n</div>\n";
},"useData":true})

});
